import React from 'react';
import { Autocomplete, Box, TextField, styled } from '@mui/material';
import { useJobsContext } from './JobsContext';
import { useSearchParam } from 'helpers/useSearchParam';

const FilterField = styled(Box)({
  minWidth: 160,
  flex: '1 1 160px',
  maxWidth: 240
});

function SelectPartner() {
  const { onPartnerChange, partners } = useJobsContext();
  const [partner] = useSearchParam('partner');

  const options = (partners || []).map((partnerName) => ({
    value: partnerName || 'no-partner',
    label: partnerName || 'No partner in job'
  }));

  const selected = options.find((option) => option.value === partner) || null;

  return (
    <FilterField>
      <Autocomplete
        clearOnEscape
        getOptionLabel={(option) => option.label || ''}
        isOptionEqualToValue={(option, selectedValue) =>
          option.value === selectedValue.value
        }
        onChange={(_event, next) => onPartnerChange(next?.value || '')}
        options={options}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Partner"
            placeholder="Search partner"
            size="small"
          />
        )}
        size="small"
        value={selected}
      />
    </FilterField>
  );
}

export default SelectPartner;
